import {wymsFetch, getParams} from '@/utils/fetch';

// 查询菜单树
export function deleteRoleInfo(args) {
    const params = getParams();
    params.append('ids', args.ids);

    return wymsFetch({
        url: 'roleInfo/deleteRoleInfo',
        method: 'GET',
        params
    });
}

// 新增角色
export function insertRoleInfo(args) {
    const params = getParams();
    params.append('constantId', args.constantId);
    params.append('isChoose', args.isChoose);
    params.append('name', args.name);
    params.append('platformType', args.platformType);
    params.append('ynDelete', args.ynDelete);

    return wymsFetch({
        url: 'roleInfo/insertRoleInfo',
        method: 'POST',
        data: params
    });
}
//查询角色列表
export function queryRoleInfoList(args) {
    const params = getParams(true, args);
    params.append('roleInfoName', args.roleInfoName);

    return wymsFetch({
        url: 'roleInfo/queryRoleInfoList',
        method: 'GET',
        params
    });
}
//查询角色详情
export function queryRoleInfo(args) {
    const params = getParams();
    params.append('id', args.id);

    return wymsFetch({
        url: 'roleInfo/queryRoleInfo',
        method: 'GET',
        params
    });
}

//编辑角色
export function updateRoleInfo(args) {
    const params = getParams();
    params.append('id', args.id);
    params.append('constantId', args.constantId);
    params.append('isChoose', args.isChoose);
    params.append('name', args.name);
    params.append('platformType', args.platformType);
    params.append('ynDelete', args.ynDelete);

    return wymsFetch({
        url: 'roleInfo/updateRoleInfo',
        method: 'POST',
        data: params
    });
}

// 查询角色类型
export function queryRoleTypeFromDict() {
    const params = getParams();

    return wymsFetch({
        url: 'roleInfo/queryRoleTypeFromDict',
        method: 'GET',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/role.js